<div class="productDetailsInstallament">
  <button *ngIf="installment.payuInstallmentEnabled" class="productDetailsInstallament__button --installamentpayu">
    <div id="payubutton"></div>
    <div class="productDetailsInstallament__tooltip">{{'productDetails.installment.pay.tooltip' | translate}}</div>
  </button>
  <button *ngIf="installment.payuPayPoEnabled" class="productDetailsInstallament__button --paypo" id="po"
          [ngClass]="{'--active': poActive}" (click)="poActive = true">
    {{'productDetails.installment.po.button' | translate}}
    <div class="productDetailsInstallament__tooltip">
      <button class="productDetailsInstallament__close flaticon flaticon-close" (click)="closePO($event)"></button>
      <iframe class="paypo__container" src="https://popup.paypo.pl" title="PayPo"></iframe>
    </div>
  </button>
</div>

